import { AddressLookupTableAccount, TransactionInstruction, VersionedTransaction, TransactionMessage, } from '@solana/web3.js';
import * as anchor from '@coral-xyz/anchor';
import { BN } from '@coral-xyz/anchor';
import { PublicKey } from '@solana/web3.js';
import { ASSOCIATED_TOKEN_PROGRAM_ID, TOKEN_PROGRAM_ID } from '@solana/spl-token';
export const getAssociatedTokenAccount = (ownerPubkey, mintPk) => {
    let associatedTokenAccountPubkey = PublicKey.findProgramAddressSync([
        ownerPubkey.toBytes(),
        TOKEN_PROGRAM_ID.toBytes(),
        mintPk.toBytes(), // mint address
    ], ASSOCIATED_TOKEN_PROGRAM_ID)[0];
    return associatedTokenAccountPubkey;
};
const createAssociatedTokenAccountInstruction = (associatedTokenAddress, payer, walletAddress, splTokenMintAddress) => {
    const keys = [
        { pubkey: payer, isSigner: true, isWritable: true },
        { pubkey: associatedTokenAddress, isSigner: false, isWritable: true },
        { pubkey: walletAddress, isSigner: false, isWritable: false },
        { pubkey: splTokenMintAddress, isSigner: false, isWritable: false },
        {
            pubkey: anchor.web3.SystemProgram.programId,
            isSigner: false,
            isWritable: false,
        },
        { pubkey: TOKEN_PROGRAM_ID, isSigner: false, isWritable: false },
        {
            pubkey: anchor.web3.SYSVAR_RENT_PUBKEY,
            isSigner: false,
            isWritable: false,
        },
    ];
    return new anchor.web3.TransactionInstruction({
        keys,
        programId: ASSOCIATED_TOKEN_PROGRAM_ID,
        data: Buffer.from([]),
    });
};
export const getATokenAccountsNeedCreate = async (connection, walletAddress, owner, nfts) => {
    let instructions = [], destinationAccounts = [];
    for (const mint of nfts) {
        const destinationPubkey = await getAssociatedTokenAccount(owner, mint);
        let response = await connection.getAccountInfo(destinationPubkey);
        if (!response) {
            const createATAIx = createAssociatedTokenAccountInstruction(destinationPubkey, walletAddress, owner, mint);
            instructions.push(createATAIx);
        }
        destinationAccounts.push(destinationPubkey);
        if (walletAddress != owner) {
            const userAccount = await getAssociatedTokenAccount(walletAddress, mint);
            response = await connection.getAccountInfo(userAccount);
            if (!response) {
                const createATAIx = createAssociatedTokenAccountInstruction(userAccount, walletAddress, walletAddress, mint);
                instructions.push(createATAIx);
            }
        }
    }
    return {
        instructions,
        destinationAccounts,
    };
};
export const getAdressLookupTableAccounts = async (keys, connection) => {
    const addressLookupTableAccountInfos = await connection.getMultipleAccountsInfo(keys.map((key) => new PublicKey(key)));
    return addressLookupTableAccountInfos.reduce((acc, accountInfo, index) => {
        const addressLookupTableAddress = keys[index];
        if (accountInfo) {
            const addressLookupTableAccount = new AddressLookupTableAccount({
                key: new PublicKey(addressLookupTableAddress),
                state: AddressLookupTableAccount.deserialize(accountInfo.data),
            });
            acc.push(addressLookupTableAccount);
        }
        return acc;
    }, new Array());
};
export const instructionDataToTransactionInstruction = (instructionPayload) => {
    if (instructionPayload === null) {
        return null;
    }
    return new TransactionInstruction({
        programId: new PublicKey(instructionPayload.programId),
        keys: instructionPayload.accounts.map((key) => ({
            pubkey: new PublicKey(key.pubkey),
            isSigner: key.isSigner,
            isWritable: key.isWritable,
        })),
        data: Buffer.from(instructionPayload.data, 'base64'),
    });
};
export const getVersionedTx = async (instructions, addressLookupTableAccounts, payerKey, connection) => {
    const blockhash = await connection.getLatestBlockhash();
    //  make versioned transaction
    const messageV0 = new TransactionMessage({
        payerKey,
        recentBlockhash: blockhash.blockhash,
        instructions,
    }).compileToV0Message(addressLookupTableAccounts);
    const transaction = new VersionedTransaction(messageV0);
    return transaction;
};
//  simulate versioned tx and get USDC vault change
export const getUsdcChange = async (transaction, connection, usdcVault) => {
    try {
        console.log('usdcVault: ', usdcVault.toBase58());
        const beforeInfo = await connection.getTokenAccountBalance(usdcVault);
        const accounts = [usdcVault.toBase58()];
        console.log('beforeInfo: ', beforeInfo.value.amount, usdcVault.toBase58());
        const config = {
            sigVerify: false,
            replaceRecentBlockhash: false,
            commitment: 'processed',
            accounts: {
                encoding: 'base64',
                addresses: accounts,
            },
        };
        const result = await connection.simulateTransaction(transaction, config);
        //  log simulation result
        console.log(result);
        if (result.value.err)
            return -1;
        const decoded = Buffer.from(result.value.accounts[0].data[0], 'base64');
        const afterBalance = new BN(decoded.subarray(64, 72).reverse()).toNumber();
        return afterBalance - parseInt(beforeInfo.value.amount);
    }
    catch (e) {
        console.log(e);
    }
};
